import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DialogStatusComponent } from 'src/app/dialog/dialog-status/dialog-status.component';
import { AppService, GRSSResponse, ValueIdPair } from 'src/app/_services/app.service';
import { ManageAccountsComponent } from '../manage-accounts.component';

@Component({
    selector: 'app-add-service-account',
    templateUrl: './add-service-account.component.html',
    standalone: false
})
export class AddServiceAccountComponent implements OnInit {

  serviceAccount: ServiceAccount;
  markets: ValueIdPair[];
  // tslint:disable-next-line: max-line-length
  constructor(private translate: TranslateService, public service: AppService, @Inject('BASE_URL') private baseUrl: string, @Inject(MAT_DIALOG_DATA) public data, private http: HttpClient, public dialogRef: MatDialogRef<ManageAccountsComponent>, private dialog: MatDialog) { }

  ngOnInit() {
    this.GetMarkets();
    this.InitializeForm();
    this.PopulateForm();
  }

  /** Gets all the markets from server */
  GetMarkets() {
    this.http.get<ValueIdPair[]>(this.baseUrl + 'api/account/getMarkets').subscribe(result => {
      this.markets = result;
    });
  }

  /** Save button event in form */
  OnSaveServiceAccount() {
    this.dialogRef.close(this.serviceAccount);
    this.service.isUpdateServiceAccount = false;
  }

  /** Cancel button event in form */
  OnCancel() {
    this.dialogRef.close(null);
  }

  /** Populkating the form with values */
  PopulateForm () {
    if (this.service.isUpdateServiceAccount) {
      this.serviceAccount = {
        serviceId: this.data.serviceId,
        generalMarketIds: this.data.generalMarketIds,
        isRequestedKey: this.data.isRequestedKey,
        isRequestedSecret: this.data.isRequestedSecret,
        name: this.data.name,
        key: this.data.key,
        secret: this.data.secret,
        notes: this.data.notes,
        enabled: this.data.enabled
      };
    } else {
      this.http.post<RequestServiceAccount>(this.baseUrl + 'api/account/requestInitializeService', this.serviceAccount).subscribe(result => {
        if (result.responseStatus.statusCode === 1) {
          this.serviceAccount = result.serviceAccount;
        } else {
          this.dialog.open(DialogStatusComponent, {
            disableClose: true,
            data: {
              title: this.translate.instant('Accounts.addServiceAccount.headerNew'),
              message: this.translate.instant('Messages.msgErrorTryAgain'),
              innerHTML: true
            },
            position: { top: '5%' }
          }).afterClosed().subscribe(res => {
            this.OnCancel();
          });
        }
      });
    }
  }

  /** Initializes the form values */
  InitializeForm() {
    this.serviceAccount = {
      serviceId: '',
      generalMarketIds: null,
      isRequestedKey: true,
      isRequestedSecret: true,
      name: '',
      key: '',
      secret: '',
      notes: '',
      enabled: false
    };
  }

  /** Generate secret button event */
  OnGenerateSecret() {
    this.serviceAccount.isRequestedSecret = true;
    this.http.post<RequestServiceAccount>(this.baseUrl + 'api/account/requestInitializeService', this.serviceAccount).subscribe(result => {
      if (result.responseStatus.statusCode === 1) {
        this.serviceAccount = result.serviceAccount;
      } else {
        this.dialog.open(DialogStatusComponent, {
          disableClose: true,
          data: {
            title: this.translate.instant('Accounts.addServiceAccount.headerNew'),
            message: this.translate.instant('Messages.msgErrorTryAgain'),
            innerHTML: true
          },
          position: { top: '5%' }
        }).afterClosed().subscribe(res => {
          this.OnCancel();
        });
      }
    });
  }

}

/** Interface to access service account details */
interface ServiceAccount {
  serviceId: string;
  generalMarketIds: string[];
  isRequestedKey: boolean;
  isRequestedSecret: boolean;
  name: string;
  key: string;
  secret: string;
  notes: string;
  enabled: boolean;
}

/** Interface to accept the response from server */
interface RequestServiceAccount {
  responseStatus: GRSSResponse;
  serviceAccount: ServiceAccount;
}
